import { useEffect } from "react";

export const useScrollRestore = (storageKey) => {
  const saveScrollPosition = () => {
    sessionStorage.setItem(storageKey, window.scrollY.toString());
  };

  useEffect(() => {
    const savedPosition = sessionStorage.getItem(storageKey);
    if (savedPosition) {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: parseInt(savedPosition, 10),
          behavior: "instant",
        });
        sessionStorage.removeItem(storageKey);
      });
    }
  }, [storageKey]);

  return { saveScrollPosition };
};
